import Point from "slotworks/utils/geom/point";
import LineResult from "./line-result";

export default class ClusterResult extends LineResult {
    public resultType: string = "ClusterResult";
    public affectedPositions: Point[];
}
